import FixedContainer from './FixedContainer.vue'

export default FixedContainer
